"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPreferences = exports.getPreferences = void 0;
const STORAGE_KEY = "@redbeemedia/javascript-player:preferences";
function getPreferences() {
    var _a;
    try {
        const item = localStorage.getItem(STORAGE_KEY);
        if (item) {
            return ((_a = JSON.parse(item)) !== null && _a !== void 0 ? _a : {});
        }
    }
    catch (e) { }
    return {};
}
exports.getPreferences = getPreferences;
function setPreferences(preferences) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign(Object.assign({}, getPreferences()), preferences)));
    }
    catch (e) {
        /* no-op */
    }
}
exports.setPreferences = setPreferences;
//# sourceMappingURL=preferences.js.map